<template>
    <sui-segment :loading="is_loading">
        <h1 is="sui-header">Device log list</h1>

        <div>
            <sui-input placeholder="Search by customer name..." v-model="search_string" />
            <sui-button v-on:click="onResetSearch" icon="trash" />
        </div>

        <sui-table class="compact" 
            celled 
            striped 
            v-for="customer in filteredItems"
            :key="customer.id"
        >
            <sui-table-header>
                <sui-table-row>
                    <sui-table-headerCell>#{{ customer.id }}</sui-table-headerCell>
                    <sui-table-headerCell colspan="3">{{ customer.name}}</sui-table-headerCell>
                </sui-table-row>
                <sui-table-row>
                    <sui-table-header-cell :width="4">ID</sui-table-header-cell>
                    <sui-table-header-cell :width="4">Name</sui-table-header-cell>
                    <sui-table-header-cell :width="4">Type</sui-table-header-cell>
                    <sui-table-header-cell :width="4">Log file</sui-table-header-cell>
                </sui-table-row>
            </sui-table-header>

            <sui-table-body>

                <sui-table-row v-for="screen in customer.screens" :key="screen.id">
                    <sui-table-cell>{{ screen.id }}</sui-table-cell>
                    <sui-table-cell>{{ screen.name }}</sui-table-cell>
                    <sui-table-cell>{{ getMotherboardString(screen.motherboardId) }}</sui-table-cell>
                    <sui-table-cell>
                        <sui-dropdown v-if="screen.logs.length > 0"
                            class="tiny"
                            text="Download"
                            direction="downward"
                            button
                            fluid
                            >
                            <sui-dropdown-menu>
                                <sui-dropdown-item v-for="log in screen.logs" :key="log.createdAt" v-on:click="downloadLog(log)">
                                    Logs from {{ toReadableDate(log.createdAt) }}
                                </sui-dropdown-item>
                            </sui-dropdown-menu>
                        </sui-dropdown>
                        <div v-else>
                            No logs available
                        </div>
                    </sui-table-cell>
                </sui-table-row>
            </sui-table-body>

        </sui-table>

    </sui-segment>

</template>

<script>
    import { api } from '@/api';
    import store from '@/store';
    
    export default {
        name: 'ScreensLogsList',
        beforeDestroy() {
            store.commit('removeAppTitle');
        },
        mounted() {
            store.commit('setAppTitle', `Devices Logs`);
        },
        data() {
            return {
                is_loading: true,
                customer_screen_array: [],
                search_string: null,
            }
        },
        created() {
            this.getScreens();
        },
        computed: {
             filteredItems() {
                if(!this.search_string) {
                    return this.customer_screen_array;
                }
                if(this.search_string.length < 2) {
                    return this.customer_screen_array;
                }
                return this.customer_screen_array.filter(c => {
                    return c.name.toUpperCase().includes(this.search_string.toUpperCase());
                });
            }
        },
        methods: {
            async getScreens() {
                this.is_loading = true;
                try {
                    const screens = await api.screens.getDeviceLog();
                    for(const screen of screens) {
                        if (!screen.customer) continue;

                        const customer = this.customer_screen_array.find(c => c.id === screen.customer.id);
                        if(customer) {
                            customer.screens.push(screen);
                        } else {
                            screen.customer.screens = [screen];
                            this.customer_screen_array.push(screen.customer);
                        }
                    }
                } finally {
                    this.is_loading = false;
                }
            },
            getMotherboardString(motherboardId) {
                switch (motherboardId) {
                    case 1:
                        return "Android Tsmart";
                    case 2:
                        return "Android Ebulent";
                    case 3:
                        return "Android Quanmax";
                    case 4:
                        return "Android Disteck";
                    case 5:
                        return "Windows";
                    case 6:
                        return "Webos";
                    case 7:
                        return "Linux";
                    default:
                        return "Unknown";
                }
            },
            toReadableDate(timestamp) {
                const date = new Date(timestamp * 1000);
                return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
            },
            downloadLog(log) {
                const downloadUri = process.env.VUE_APP_STATIC_URL + log.uri;
                window.open(downloadUri, "_blank");
            },
            onResetSearch() {
                this.search_string = null;
            },
        }
    }
</script>